export class AuthenticatedUser {
  public access_token: string;
  public token_type: string;
  public expires_in: string;
  public scope: string[];
  public uid: string;

  constructor() {}
}
